import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_ENFORCE_SECURE_IDENTIFIED_STATE = createFcmDetails('enforce_secure_identified_state', {
	owner: 'Site Platform',
	context: 'Signatures',
	description:
		'This flag prevents guest users from signing unless authenticated if they match an existing user. It also prevents a user from getting a list of signed petition if they are not authenticated.',
	import: false,
});
